import Transformer from './transformer';

export default class EmployeeTransformer extends Transformer {
  static fetch(employee) {
    return {
      id: employee.id,
      active: employee.active,
      category1: employee.choice1 ? employee.choice1 : null,
      category2: employee.choice2 ? employee.choice2 : null,
      category3: employee.choice3 ? employee.choice3 : null,
      category4: employee.choice4 ? employee.choice4 : null,
      email: employee.email,
      invited: employee.invited,
      quota: employee.quota,
      quota_per_head: employee.quota_per_head,
      refresh_quota: employee.refresh_quota,
      is_use_employee_quota_config: employee.is_use_employee_quota_config,
      stress_test_required: employee.stress_test_required,
      user_id: employee.user_id,
      created_at: employee.created_at,
    };
  }
}
